module.exports = __webpack_public_path__ + "assets/img/eagle-one.fb838de7.jpg";